import { useNavigate } from "react-router-dom";
import { STRATEGY_LIST } from "../data/platformStrategiesData";
import * as Icons from "lucide-react";
import { ArrowUpRight, Layers } from "lucide-react";

const Icon = ({ name, className, color }) => {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} style={{ color }} strokeWidth={1.5} />;
};

export default function StrategiesHub() {
  const nav = useNavigate();

  return (
    <div className="space-y-8 animate-fadeUp" data-testid="strategies-hub">
      <header className="border-l-2 border-[#CCFF00] pl-5">
        <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#CCFF00] mb-2">// HUB STRATÉGIES</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-white tracking-tight">Stratégies Plateformes</h1>
        <p className="text-zinc-400 mt-2 max-w-2xl">Pas la théorie : l'exécution. Choisis une plateforme pour ouvrir ses formats prioritaires, hooks, routines et leviers de scaling.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {STRATEGY_LIST.map(s => (
          <button
            key={s.slug}
            onClick={() => nav(`/strategies-plateformes/${s.slug}`)}
            data-testid={`strat-card-${s.slug}`}
            className="group text-left border border-[#1E1E24] bg-[#0A0A0C] hover:border-[#CCFF00]/40 rounded-sm p-6 transition-all"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="w-11 h-11 rounded-sm flex items-center justify-center border" style={{ background: `${s.color}15`, borderColor: `${s.color}40` }}>
                <Icon name={s.icon} className="w-5 h-5" color={s.color} />
              </div>
              <ArrowUpRight className="w-4 h-4 text-zinc-600 group-hover:text-[#CCFF00] transition-colors" />
            </div>
            <h3 className="font-display text-xl font-semibold text-white mb-2">{s.name}</h3>
            <p className="text-sm text-zinc-400 mb-4 leading-relaxed">{s.tagline}</p>
            <div className="flex items-center gap-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500 pt-3 border-t border-[#1E1E24]">
              <Layers className="w-3 h-3" />
              <span>{s.sections.length} sections</span>
              <span className="ml-auto" style={{ color: s.color }}>OPEN →</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
